export class AcceptInvitation {
  public userId!: string;
  public code!: string;
  public voornaam!: string;
  public tussenvoegsels!: string;
  public achternaam!: string;
  public mobiel!: string;
  public password!: string;
  public confirmPassword!: string;
}